module.exports = __webpack_public_path__ + "static/media/backspace.9cfddbe6.svg";